import { ENTRYPOINT } from '../../../config/entrypoint';
import { API_ROUTES } from '../../../constants/api_routes';
import { CONTENT_TYPE, TOKEN_TYPE } from '../../../constants/constants';
import { REACT_ROUTES } from '../../../constants/react_routes';
import { deleteData, getData, getHeaders, postData, putData } from '../../../http/request';
import history from '../../../services/history';

export const AREA_ACTION_TYPES = {
	GET_AREAS_SUCCESS: 'GET_AREAS_SUCCESS',
    POST_AREA_SUCCESS: 'POST_AREA_SUCCESS',
    PUT_AREA_SUCCESS: 'PUT_AREA_SUCCESS',
    DELETE_ARTICLE_SUCCESS: 'DELETE_CUSTOMER_SUCCESS',
    UPDATE_AREAS_PAGINATION: 'UPDATE_AREAS_PAGINATION'
};

const AREAS_URL = `${ENTRYPOINT}${API_ROUTES.AREAS}`;

const getPaginationParams = ({ page, rowsPerPage }) => {
    return `?page=${page+1}&itemsPerPage=${rowsPerPage}&pagination=true`;
}

const getFilterParams = (params, filters = {}) => {
    const { search } = filters;
    let filterParams = params;
    if (search) {
        filterParams = `${filterParams}&search=${search}`;
    }
    return filterParams;
}

export const getAreas = (data = { page: 0, rowsPerPage: 10, filters: { } }) => {
    return async (dispatch) => {
        let params = getPaginationParams(data);
        const { filters } = data;
        params = getFilterParams(params, filters);
        const GET_AREAS_URL = `${AREAS_URL}${params}`;
        const response = await getData(GET_AREAS_URL, getHeaders(TOKEN_TYPE.TOKEN, CONTENT_TYPE.LD_JSON));
        dispatch({ type: AREA_ACTION_TYPES.GET_AREAS_SUCCESS, payload: response['hydra:member'] });
        dispatch({ type: AREA_ACTION_TYPES.UPDATE_AREAS_PAGINATION, payload: { totalCount: response['hydra:totalItems'] } });
    }
}

export const getArea = async (uuid) => {
    const GET_AREA_URL = `${AREAS_URL}/${uuid}`;
    return await getData(GET_AREA_URL, getHeaders());
}

export const postArea = (data) => {
    return async (dispatch) => {
        const response = await postData(AREAS_URL, data);
        dispatch({ type: AREA_ACTION_TYPES.POST_AREA_SUCCESS, payload: response });
        return history.push(REACT_ROUTES.AREAS);
    }
}

export const putArea = (uuid, data) => {
    return async (dispatch) => {
        const PUT_AREA_URL = `${AREAS_URL}/${uuid}`;
        const response = await putData(PUT_AREA_URL, data);
        dispatch({ type: AREA_ACTION_TYPES.PUT_AREA_SUCCESS, payload: response });
        history.push(REACT_ROUTES.AREAS);
    }
}

export const deleteArea = (uuid) => (
    async () => {
        const DELETE_AREA_URL = `${AREAS_URL}/${uuid}`;
        await deleteData(DELETE_AREA_URL);
        // dispatch({ type: CUSTOMERS_ACTION_TYPES.DELETE_CUSTOMER_SUCCESS, payload: uuid });
    }
)

export const updateAreasPagination = ({ rowsPerPage, page = 0, filters }) => {
    return (dispatch) => {
        dispatch({ type: AREA_ACTION_TYPES.UPDATE_AREAS_PAGINATION, payload: { rowsPerPage, page, filters } });
        dispatch(getAreas({ page, rowsPerPage, filters }));
    }
}

